<template>
  <div class="text-start bg-white text-start ">
    <div class="font-semibold uppercase mb-4 text-gray-600">Subscribe to {{ reportName }}</div>

    <table class="table-auto w-full mb-3 border">
      <thead>
      <tr class="border-b font-bold">
        <td class="px-3 py-2"></td>
        <td class="px-3 py-2">Report</td>
        <td class="px-3 py-2">Send Time</td>
        <td class="px-3 py-2"></td>
      </tr>
      </thead>
      <tbody>
      <tr class="border-t hover:bg-gray-200" v-for="(record,index) in myReports" :key="record.id">
        <td class="px-3 py-2 font-bold">
          {{ index + 1 }}
        </td>
        <td class="px-3 py-2">{{ reports[record.report] }}</td>
        <td class="px-3 py-2">{{ record.send_at }}:00 Hours</td>
        <td class="px-3 py-2">
          <button type="submit" v-on:click="unsubscribeReport(record.id)"
                  class="py-1 px-2 text-xs bg-red-500 hover:bg-red-700 font-semibold text-white hover:border-transparent rounded">
            Unsubscribe
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="mt-6">
      <div class="relative rounded-md shadow-sm">
        <label class="block text-sm ">Send Report at<span class="text-red-700">*</span></label>
        <select v-model="sendAt" class="input">
          <option v-for="i in 24" :key="i" :value="i<10 ? ('0'+i) : i"> {{ i &lt; 10 ? '0' + i : i }}:00 Hours</option>
        </select>
      </div>
    </div>
    <div class="mt-6 text-right">
      <button type="submit" v-on:click="saveRecord"
              class="py-2 px-4 uppercase bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent rounded">
        Subscribe
      </button>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";

export default {
  name: "SubscribeReport",
  components: {},
  data() {
    return {
      sendAt: 18,
      errors: [],
      myReports: [],
      reports: {
        'new_visitors': 'First Time Visitors',
        'unique_visitors': 'Unique Visitors',
        'all_visitors': 'All Visitors',
        'repeat_visitors': 'Repeat Visitors',
        'footfall': 'Footfall',
      },
    }
  },
  props: {
    breadcrumb: {type: Boolean, default: true},
    reportName: String,
    report: String
  },
  mounted() {
    this.getSubscriptions()
  },
  methods: {
    getSubscriptions() {
      GraphQl.sendRequest('{myReports{id report send_at}}')
          .then(response => {
                this.myReports = response.myReports;
              }
          )
    },
    saveRecord() {
      let params = 'report: "' + this.report + '", sendTime: "' + this.sendAt + '"';
      GraphQl.sendRequest('mutation{subscribeReport(' + params + '){code message recordId}}')
          .then(response => {
            this.$root.$emit(response.subscribeReport.code === 200 ? 'alert_success' : 'alert_error', [response.subscribeReport.message]);
            if (response.subscribeReport.code === 200)
              this.$root.$emit("hide_modal");
          })
    },
    unsubscribeReport(id) {
      let params = 'id: "' + id + '"';
      GraphQl.sendRequest('mutation{unsubscribeReport(' + params + '){code message recordId}}')
          .then(response => {
            this.$root.$emit(response.unsubscribeReport.code === 200 ? 'alert_success' : 'alert_error', [response.unsubscribeReport.message]);
          }).finally(() => {
        this.getSubscriptions()
      })
    }
  }
}
</script>

<style></style>